<script lang="ts" setup>
import insightService, { InsightItem } from '@/services/insight.service';
import { Mutations } from '@/store';
import { markRaw, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import LearningItemForm from '../learning/LearningItemForm.vue';
import EventItemForm from '../events/EventItemForm.vue';
import StoryForm from '../stories/StoryForm.vue';
import storiesService from '@/services/stories.service';
import { Story } from '@/models/story.model';
import ContentItemForm from './ContentItemForm.vue';
import { TYPE_INITIATIVE } from '@/util/constants';

const items = ref<InsightItem[]>([]);
const store = useStore();

onMounted(async () => {
  const result = await insightService.getListWithoutCategories();

  items.value = [...result];
});

async function editStory(s: Story) {
  const story = await storiesService.get(s.id);
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(StoryForm),
    data: story.data,
  });
}

function editItem(_: PointerEvent, { item }: { item: InsightItem }) {
  switch (item.type) {
    case 'Initiative':
      store.commit(Mutations.ShowDrawer, {
        component: markRaw(ContentItemForm),
        data: {
          type: TYPE_INITIATIVE,
          contentItem: item.item,
        },
      });
      break;
    case 'Event Item':
      store.commit(Mutations.ShowDrawer, {
        component: markRaw(EventItemForm),
        data: item.item,
      });
      break;
    case 'Learning Item':
      store.commit(Mutations.ShowDrawer, {
        component: markRaw(LearningItemForm),
        data: item.item,
      });
      break;
    case 'Quiz':
      editStory(item.item as Story);
      break;
  }
}

const headers = [
  { title: 'ID', key: 'item.id', width: '5%' },
  { title: 'Type', key: 'type', width: '10%' },
  { title: 'Title', key: 'item.title', width: '35%' },
  { title: 'Category', key: 'item.mainCategory.title', width: '25%' },
  { title: 'Problem', key: 'message', width: '25%' },
];
</script>
<template>
  <v-container>
    <h2>Items with missing categories or main category</h2>
    <v-data-table :headers="headers" :items="items" @click:row="editItem">
    </v-data-table>
  </v-container>
</template>
